import { Component, OnInit } from '@angular/core';

import { HttpService } from '@shared/data-access/services';

@Component({
	selector: 'my-account-templates-not-found',
	templateUrl: './not-found.component.html',
	styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
	constructor(private httpService: HttpService) {}

	ngOnInit() {
		// Set the HTTP Status Code to 404
		this.httpService.setStatusCode(404);
	}
}
